export enum WordMatch {
  PARTIAL,
  EXACT,
  NONE,
}

export default function () {
  function findWordsInText(text: string, search: string): WordMatch {
    const words = search.split(' ').map((word) => word.toLowerCase().trim());
    const textLower = text.toLowerCase();
    if (textLower.includes(search)) {
      return WordMatch.EXACT;
    }
    let partialMatch = true;
    for (const word of words) {
      if (!textLower.includes(word)) {
        partialMatch = false;
      }
    }
    return partialMatch ? WordMatch.PARTIAL : WordMatch.NONE;
  }

  function highlightWordsInText(
    text: string,
    search: string,
    highlightClass = 'highlight',
  ): { partialString: string; className: string }[] {
    const escapeRegExp = (string: string) =>
      string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const words = search.split(' ').map((word) => word.toLowerCase().trim());

    const wordRegex = new RegExp(words.map(escapeRegExp).join('|'), 'gi');
    // Split the text into parts
    const parts = [];
    let lastIndex = 0;

    text.replace(wordRegex, (match, offset: number) => {
      // Add the text before the match
      if (lastIndex < offset) {
        parts.push({
          partialString: text.slice(lastIndex, offset),
          className: '',
        });
      }
      // Add the matched text
      parts.push({
        partialString: match,
        className: highlightClass,
      });
      lastIndex = offset + match.length;
      return match;
    });

    // Add any remaining text after the last match
    if (lastIndex < text.length) {
      parts.push({
        partialString: text.slice(lastIndex),
        className: '',
      });
    }
    return parts;
  }

  return {
    findWordsInText,
    highlightWordsInText,
  };
}
